<template>
  <v-container class="mt-4">
    <v-row justify-center>
      <v-col class="'text-h5'" cols="12">{{$t('commons.error.message')}}</v-col>
      <v-col class="text-subtitle-1" cols="12">
        <router-link :to="{ path: '/'}">{{$t('commons.error.back')}}</router-link>
      </v-col>
    </v-row>
  </v-container>
</template>
